import './SideNav.css';const sideNav = "_sideNav_xdqp4_1";
const sideNav__button = "_sideNav__button_xdqp4_37";
const styles = {
  sideNav,
  "sideNav--hidden": "_sideNav--hidden_xdqp4_34",
  sideNav__button
};
export {
  styles as default,
  sideNav,
  sideNav__button
};
